import { userApi } from "services/actions/users";

const pickUserId = (id) => {
  if (typeof id === 'object' && id !== null) return '';
  return String(id || '').trim();
};

async function checkUserExist(id) {
  try {
    const response = await userApi.getById(id, null); // unitId null
    return response.data;
  } catch (e) {
    return null;
  }
}

async function mapWithConcurrency(items, concurrency, asyncFn) {
  const results = [];
  const executing = [];
  for (const item of items) {
    const p = Promise.resolve().then(() => asyncFn(item));
    results.push(p);
    if (concurrency <= items.length) {
      const e = p.then(() => {
        const idx = executing.indexOf(e);
        if (idx !== -1) executing.splice(idx, 1);
      });
      executing.push(e);
      if (executing.length >= concurrency) {
        await Promise.race(executing);
      }
    }
  }
  return Promise.all(results);
}


async function bulkFetchUsersByIds(ids, unitId = null) {
  try {
    const response = await userApi.bulkFetchUsersByIds(ids, unitId);
    return response.data;
  } catch (error) {
    return null;
  }
}

async function bulkCheckUsers(userIds, unitId) {
  const out = new Map();
  if (!userIds?.length) return out;

  for (let start = 0; start < userIds.length; start += 500) {
    const chunk = userIds.slice(start, start + 500);

    try {
      let data = null;

      try {
        data = await bulkFetchUsersByIds(chunk, unitId);
      } catch (error) {
        data = null; // force fallback
      }

      // Monta índice por múltiplas chaves possíveis
      const index = new Map();
      const put = (k, u) => {
        const key = String(k ?? '').trim();
        if (key) index.set(key, u);
      };

      if (Array.isArray(data?.users)) {
        for (const u of data.users) {
          put(u?.id, u);
          put(u?.uuid, u);
          put(u?._id, u);
          put(u?.userId, u);
        }
      } else if (data?.users && typeof data.users === 'object') {
        for (const [k, u] of Object.entries(data.users)) {
          put(k, u);
          put(u?.id, u);
          put(u?.uuid, u);
          put(u?._id, u);
          put(u?.userId, u);
        }
      }

      if (index.size > 0) {
        // Preenche a partir do índice
        for (const idRaw of chunk) {
          const id = String(idRaw ?? '').trim();
          const u = index.get(id);
          const name = (u?.firstName && u?.lastName) ? `${u.firstName} ${u.lastName}` : 'N/A';
          if (u) {
             out.set(id, name);
          }
        }
      }
    } catch (err) {
      // Erro externo — ignora e segue, resultando em 'N/A' no chamador
      console.error("Error in bulkCheckUsers chunk processing:", err);
    }
  }

  return out;
}

export async function resolveUserNames(userIdsRaw, unitId = null) {
  try {
    const unique = Array.from(
      new Set(
        (userIdsRaw || [])
          .map(pickUserId)
          .filter((v) => v && v.length)
      )
    );

    if (!unique.length) return new Map();
    const map = await bulkCheckUsers(unique, unitId);
    // garante que todos tenham uma entrada
    for (const id of unique) {
      if (!map.has(id)) map.set(id, 'N/A');
    }
    return map;
  } catch (error) {
    console.error("Error resolving user names:", error);
    return new Map();
  }
}
